/**
 * Runtime environment resolution.
 *
 * Centralises how the app discovers the backend origin so the axios client and
 * any future consumer read from one place instead of re-deriving it.
 */
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

export function apiOrigin(): string {
  const configured = import.meta.env?.VITE_API_ORIGIN as string | undefined;
  if (configured) return configured.replace(/\/$/, '');

  if (typeof window !== 'undefined' && LOCAL_HOSTS.has(window.location.hostname)) {
    return '';
  }

  return 'https://api.maktechacademy.com';
}

export function apiUrl(path: string): string {
  return `${apiOrigin()}${path}`;
}
